import makeStyles from '@mui/styles/makeStyles';

const styles = (theme) => ({
    copiedIcon: {
        width: '14px',
        height: '14px',
        color: '#FFFFFF',

        '&.MuiSvgIcon-root': {
            width: '16.8px', // this size is set so that the SVG inside will be 14x14pxg
            height: '16.8px',
        },
    },
});

export default styles;
export const useStyles = makeStyles(styles);
